var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoSmallDl = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 136,
  height: 138.667,
  viewBox: "0 0 102 104",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.4 4.1C41.2 5.5 33 11 28.9 16.4c-6.6 8.7-8.5 19-5.4 29.4 1.5 4.9 1.8 5.2 4.8 5.2 4 0 13.7-1.4 21.4-3.1l5.8-1.2-3.5-.9c-7.6-2.1-13.9-9.9-14-17.4 0-3.8 4.3-12.4 7.4-14.6 9-6.5 22.3-3.3 27 6.6 2.3 4.8 2.1 12.3-.5 16.5-1.1 1.8-1.8 3.5-1.6 3.7.5.5 15.1-8.1 16.4-9.8.8-1 .6-2.6-.8-6.3-3.6-9.7-12.2-17.3-22.5-20-6.4-1.7-9.9-1.7-16-.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.3 15.5c-4 1.7-7.3 6.9-7.3 11.3 0 11.1 11.6 17.4 20.8 11.4 7.8-5.1 6.4-19.1-2.3-22.8-4.3-1.7-7.1-1.7-11.2.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.8 15.7c.6.2 1.2 1.9 1.2 3.6 0 5.3-10.9 14.3-26.9 22.2C56.3 48.8 39.7 53 25.6 53c-12 0-17.7-4.7-14.8-12.2.6-1.8 1-3.3.8-3.5-.8-.8-7.4 5.8-8.6 8.6-1.7 4.3.2 9.6 4.3 11.9 2.6 1.3 5.7 1.7 15.2 1.7 13.8-.1 24.6-2.6 40.3-9.3 17.4-7.5 33.7-19.8 37.1-28 1.2-2.9 1.2-3.5-.4-5.2-1-1.1-2.3-2-2.9-1.9-.6 0-.6.3.2.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82 41.7c-9.9 7.9-28.3 15.8-42.8 18.5-3.5.7-6.6 1.7-6.9 2.4-.7 1.8 16.3 35 18.9 36.8 3.3 2.3 6.6 2 9.7-1.2 1.7-1.7 7.1-13.1 15-31.5 6.8-15.9 12.2-29 12-29.1-.2-.2-2.9 1.6-5.9 4.1"
}))));
export { SvgLogoSmallDl as ReactComponent };
export default __webpack_public_path__ + "assets/images/logo-small-DL.svg";